import SampleColorCard from "../components/Card/SampleColorCard";
import Restricted from "../context/Restricted";
import {useNavigate} from "react-router-dom";
import {ReportAllService, ReportUserService, services} from "../services";
import {pushToast} from "../utils/pushToast";
import {useEffect, useState} from "react";
import Loading from "../components/Loading";
import FireBaseNotification from "../components/FireBaseNotification";
import '../firebase';
import {useAuth} from "../context/AuthContext"; // مطمئن شوید که مسیر درست است
import React from "react";
import { enablePushAndGetToken } from "../firebase";
import { SaveToken } from "../services";


export default function Dashboard() {
    const navigate = useNavigate();
    const [allServiceList,seAllServiceList] = useState([]);
    const [userServiceList,seUserServiceList] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const auth = useAuth();

    const [status, setStatus] = useState("");

    const onEnable = async () => {
        setStatus("Requesting permission...");
        const token = await enablePushAndGetToken();

        if (!token) {
            setStatus("Push not enabled (permission denied or SW failed).");
            return;
        }

        setStatus("Saving token...");
        try {
            await SaveToken({ token });
            setStatus("Push enabled ✅");
        } catch (e) {
            setStatus("Token got, but save failed.");
            console.error(e);
        }
    };
    const loadAllServices = async () =>{

        setIsLoading(true)
        try {

            const {data,status} = await ReportAllService();
            if(status === 200){
                seAllServiceList(data);

            }
            setIsLoading(false)
        } catch (ex){
            //pushToast("خطای سرور", "error");
            //setIsLoading(false)
        }
    }
    const loadUserServices = async () =>{
        setIsLoading(true)
        try {

            const {data,status} = await ReportUserService();
            if(status === 200){
                seUserServiceList(data);

            }
            setIsLoading(false)
        } catch (ex){
            //pushToast("خطای سرور", "error");
            setIsLoading(false)
        }
    }
    useEffect(() => {
        loadUserServices()
        loadAllServices()
    }, [])

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {/*<h6 className="mt-2 fw-normal text-success">داشبورد</h6>*/}
                    {/*<hr className="mt-0"/>*/}
                    {/*<div className="row gy-4" >*/}
                    {/*    /!*<Restricted to="ServiceServiceList">*!/*/}
                    {/*    /!*    <SampleColorCard name={"ثبت درخواست جدید"} colorClass={"bg-success"} publicClass={'fix-height font-11'} click={()=>navigate("/service/new")}></SampleColorCard>*!/*/}
                    {/*    /!*</Restricted>*!/*/}
                    {/*    <Restricted to="UserUserList">*/}
                    {/*        <SampleColorCard name={"لیست کاربران"} colorClass={"bg-primary"} publicClass={'fix-height'} click={()=>navigate("/user/list?page=1&pageSize=20")}></SampleColorCard>*/}
                    {/*    </Restricted>*/}
                    {/*    <Restricted to="ServiceCategoryServiceCategoryList">*/}
                    {/*        <SampleColorCard name={" دسته بندی خدمات"} colorClass={"bg-secondary"} publicClass={'fix-height'} click={()=>navigate("/service-category/list?page=1&pageSize=20")}></SampleColorCard>*/}
                    {/*    </Restricted>*/}
                    {/*    /!*<Restricted to="ServiceServiceManServiceList">*!/*/}
                    {/*    /!*    <SampleColorCard name={"لیست درخواست ها"} colorClass={"bg-success"} publicClass={'fix-height'} click={()=>navigate("/service-man/list?type=0&page=1&pageSize=20")}></SampleColorCard>*!/*/}
                    {/*    /!*</Restricted>*!/*/}
                    {/*    /!*<FireBaseNotification />*!/*/}
                    {/*</div>*/}
                </div>
            </div>
            <Restricted to="ServiceManage1">
            <hr />
            <div className="row">
                <div className="col-12">
                    <h6 className="mt-2 fw-normal text-success">اطلاعات همه سرویس ها</h6>
                    <hr className="mt-0"/>
                    <div className="row gy-4" >

                            {allServiceList.map(item => {
                               return <SampleColorCard name={item.name+`(${(item.count)})`} colorClass={"bg-success card-text-black"}
                                                 publicClass={'fix-height'} color={item.color} click={()=>navigate(`/service/list?page=1&pageSize=20&statusId=${item.id}`)}
                                                ></SampleColorCard>
                            })
                            }


                    </div>
                </div>
            </div>
            </Restricted>
            <hr />
            <div className="row">
                <div className="col-12">
                    <Restricted to="ServiceManage2">
                    <h6 className="mt-2 fw-normal text-success">اطلاعات سرویس ها</h6>
                    <hr className="mt-0"/>
                    </Restricted>
                    <div className="row gy-4">
                        <button onClick={onEnable}>
                            فعال‌سازی اعلان‌ها
                        </button>
                        <Restricted to="ServiceManage2">
                            <Restricted to="ServiceServiceManServiceList">
                                <SampleColorCard name={"ثبت درخواست جدید"} colorClass={"bg-success"}
                                                 publicClass={'fix-height font-11'}
                                                 click={() => navigate("/service-man/new")}></SampleColorCard>
                            </Restricted>
                            {userServiceList.map(item => {
                                return <SampleColorCard name={item.name + `(${(item.count)})`}
                                                        colorClass={"bg-success card-text-black"}
                                                        click={() => navigate(`/service-man/list?page=1&pageSize=20&statusId=${item.id}`)}
                                                        publicClass={'fix-height'} color={item.color}
                                ></SampleColorCard>
                            })
                            }
                        </Restricted>

                    </div>
                </div>
            </div>
            {
                isLoading ? (<Loading/>) : null
            }
        </>
    )
}